import { createApp } from "vue";

import ElementPlus from "element-plus";
import it from "element-plus/dist/locale/it.mjs";
import "./styles/element/index.scss";
import "element-plus/theme-chalk/src/message.scss";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import App from './App.vue'
import router from './router'

import { createPinia } from "pinia";

const app = createApp(App);

app.use(router);

app.use(ElementPlus, {
    locale: it
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

library.add(fas);
app.component("font-awesome-icon", FontAwesomeIcon);

const pinia = createPinia();
app.use(pinia);

app.mount("#app");